import { measureCompHeight } from './utils';
export default function create(_options, dom) {
  if (dom) {
    measureCompHeight({
      compHeight: 0
    }, dom, true);
  }
  return [];
}
//# sourceMappingURL=BgReveal.js.map